angular.module('bb.listing_view').component('listingViewInternal', {
  controller: ListingViewInternalController,
  controllerAs: 'vm',
  template: `<listing-view ng-if="vm.listing" listing="vm.listing" listingInfo="vm.listingInfo"/>`,
  bindings: {},
});

ListingViewInternalController.$inject = [
  'ListingViewService',
  'ErrorService',
  '$routeParams',
];

function ListingViewInternalController(
  ListingViewService,
  ErrorService,
  $routeParams,
) {
  const vm = this;
  vm.$onInit = function () {
    ListingViewService.getListingInternalView($routeParams.listingId)
      .then(({ listing, listingInfo }) => {
        vm.listing = listing;
        vm.listingInfo = listingInfo;
      })
      .catch(err => {
        if (err.status === 403) {
          ErrorService.toastyHTTPErr({ data: 'Forbidden', status: 403 });
          window.history.go(-1);
        }
        throw err;
      });
  };
}

export {};
